module.exports = __webpack_public_path__ + "img/theesports2013wintercollection.c44ee6c2.png";